import $ from "jquery";

const whyAccordionToggler = () => {
  const init = () => {
    whyAccordionToggle();
  };

  const whyAccordionToggle = () => {
    const el = {
      accordionItem: "div.whyAccordion-item",
      accordionTitle: "div.whyAccordion-title",
      accordionIcon: "div.whyAccordion-title .icon",
      accordionContent: "div.whyAccordion-content",
      accordionImage: "img.whySection-icon.active",
    };

    $(el.accordionItem || el.accordionTitle).on("click", (e) => {
      const parent = $(e.target.closest(".whySection"));

      if (
        parent.find(`.${$(e.target).attr("data-target")}`).hasClass("closed")
      ) {
        parent.find($(el.accordionContent)).addClass("closed");
        parent.find($(el.accordionImage)).addClass("closed");
        parent
          .find(`.${$(e.target).attr("data-target")}`)
          .removeClass("closed");
      } else {
        parent.find($(el.accordionImage)).addClass("closed");
        parent.find($(el.accordionContent)).addClass("closed");
        parent.find($(el.accordionIcon)).addClass("closed");
      }
    });
  };

  init();
};

try {
  whyAccordionToggler();
} catch (error) {
  console.log(error);
}
